import { Navigate, Outlet } from 'react-router-dom'
import { useAuthState } from './auth'

const ProtectedRoutes = (props: any) => {
  const { isAuthenticated, isLoading } = useAuthState()
  return isAuthenticated || isLoading ? <Outlet /> : <Navigate to="/login" />
}

export default ProtectedRoutes
